import React, { Component } from 'react';
import { Button, Card, CardBody, CardGroup, Col, Container, Alert, Row } from 'reactstrap';
import { ValidationForm } from "react-bootstrap4-form-validation";
import _ from "lodash";
import { Redirect } from 'react-router-dom';
import Http from '../../../services/Http';
import apiPath from '../../../constants/apiPath';
import { adminLogin } from "../../../actions/index";
import { connect } from "react-redux";
import OtpInput from 'react-otp-input';
import logo from '../../../assets/img/brand/logo.png';
const mapStateToProps = state => {
  return { admin: state.admin };
};

const mapDispatchToProps = dispatch => {
  return {
    adminLogin: admin => dispatch(adminLogin(admin))
  };
};

class VerifyOTP extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      loading: false,
      immediate: true,
      setFocusOnError: true,
      clearInputOnReset: false,
      email: localStorage.getItem('adminEmail'),
      mobile:localStorage.getItem('adminMobile'),
      otp:localStorage.getItem('adminOtp'),
      isMailSent: false
    }
  }

  handleChange = otp => this.setState({ otp });

  handleSubmit = (e, formData, inputs) => {
    e.preventDefault();
    this.verifyOTP(formData);
  }


  resetForm = () => {
    let formRef = this.formRef.current;
    formRef.resetValidationState(this.state.clearInputOnReset);
  }

  async verifyOTP(postData) {
    let path = apiPath.unlockAccountVerifyOTP;
      this.setState({ loading: true });
      let postDatas= {}
        postDatas.mobile =this.state.mobile;
        postDatas.email =this.state.email;
        postDatas.otp =this.state.otp;
      let options = {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(postDatas)
      }
      
      let result = await Http(path, options);
      this.setState({ loading: false });
      if (result.ok) {
        if (result.status === 200) {

          let resultData = await result.json();
          if (resultData.success) {
            localStorage.removeItem('adminMobile');
            localStorage.removeItem('adminEmail');
            localStorage.removeItem('adminOtp');
            
            this.setState({ submitFormSuccess: resultData.msg});
            setTimeout(() => {
              this.setState({ submitFormSuccess: null });
            }, 5000);
            this.resetForm();
            window.location = "/login"
          } else {
            this.setState({ submitFormError: resultData.msg, submitFormSuccess: null });
            setTimeout(() => {
              this.setState({ submitFormError: null });
            }, 5000);
          }
        }
      } else {
        this.setState({ submitFormError: result.statusText, submitFormSuccess: null });
        setTimeout(() => {
          this.setState({ submitFormError: null });
        }, 5000);
      }
  }

  responseError() {
    if (this.state.submitFormError) {
      return <Alert color="danger">
        {this.state.submitFormError}
      </Alert>
    } else {
      return null;
    }
  }

  responseSuccess() {
    if (this.state.submitFormSuccess) {
      return <Alert color="success">
        {this.state.submitFormSuccess}
      </Alert>
    } else {
      return null;
    }
  }

  showLoading() {
    if (this.state.loading) {
      return <i className="fa fa-spinner fa-spin"></i>
    }
  }

  render() {

    if (!_.isEmpty(this.props.admin)) {
      return <Redirect to='/dashboard' />
    }

    return (
      <div className="app flex-row align-items-center login-body">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="forgot-password-card">
                  {this.responseError()} {this.responseSuccess()}
                  <CardBody className="p-0">
                    <ValidationForm onSubmit={this.handleSubmit} onErrorSubmit={this.handleErrorSubmit}
                      ref={this.formRef}
                      immediate={this.state.immediate}
                      setFocusOnError={this.state.setFocusOnError}
                      defaultErrorMessage={{ required: "Please enter something." }} >
                        <div className="logoouteradmin"><img src={logo} alt="Lavender Logo"/></div>
                        <div className="loginbox p-4">
                        <h3 className="otp_head">Verify OTP for Unlock your Account</h3>
                        <input type="hidden" name="mobile" value={this.state.mobile}/>
                        <input type="hidden" name="email" value={this.state.email}/>
                        <div className="otp_container">
                            <OtpInput
                                className="otp_control opt-btn"
                                value={this.state.otp}
                                onChange={this.handleChange}
                                numInputs={4}
                                isInputNum={true}
                                containerStyle={{justifyContent:'center'}}
                                focusStyle={false}
                            />
                        </div>  
                      <Row className="text-center">
                        <Col xs="12">
                          <Button disabled={this.state.loading} color="primary" type={"submit"} className="px-4">Submit {this.showLoading()}</Button>
                        </Col>
                       
                      </Row>
                      </div>
                    </ValidationForm>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(VerifyOTP);
